import Vue from "vue"
const Basket = {
  install: Vue => {
    const root = new Vue({
      data() {
        return {
          basket: {}
        }
      }
    })
    Vue.prototype.$basket = root
  }
}
Vue.use(Basket)
